// extracted by mini-css-extract-plugin
module.exports = {"partnerInfoWrapper":"_1WwDh","partnerIntoContent":"_1vhqF"};